import { render, staticRenderFns } from "./SpFieldRecordCreate.vue?vue&type=template&id=37d13504&"
import script from "./SpFieldRecordCreate.vue?vue&type=script&lang=ts&"
export * from "./SpFieldRecordCreate.vue?vue&type=script&lang=ts&"
import style0 from "./SpFieldRecordCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports